import { Navigate, Outlet } from "react-router-dom";
import React from "react";
import { LoginServices } from "../services/LoginServices";
import Header from "../components/Header/Header";


const ProtectedRoute = () => {
  return (
    LoginServices.verifySession() ?
      <div className="flex flex-col w-full h-full overflow-y-auto">
        <Header />
        <Outlet />
      </div>
      :
      <Navigate to="/login" replace />
  );
}
export default ProtectedRoute;